import * as z from "zod";

export const ThirdPartyFulfillmentWeeklyOrderLimits = z
  .array(z.number().int().positive().max(1_000_000).nullable())
  .length(7);
export type ThirdPartyFulfillmentWeeklyOrderLimits = z.infer<
  typeof ThirdPartyFulfillmentWeeklyOrderLimits
>;

export const THIRD_PARTY_FULFILLMENT_BUDGET_DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export function getThirdPartyFulfillmentBudgetDay(
  now: Date,
  timeZone: string,
): { date: string; weekday: number } {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    weekday: "long",
  }).formatToParts(now);
  const part = (type: string) => {
    const value = parts.find((entry) => entry.type === type)?.value;
    if (!value) {
      throw new Error(`Missing budget calendar component: ${type}`);
    }
    return value;
  };
  const weekday = THIRD_PARTY_FULFILLMENT_BUDGET_DAYS.indexOf(part("weekday"));
  if (weekday < 0) {
    throw new Error("Invalid budget weekday");
  }
  return { date: `${part("year")}-${part("month")}-${part("day")}`, weekday };
}

export function getThirdPartyFulfillmentOrderLimit(
  limits: ThirdPartyFulfillmentWeeklyOrderLimits,
  weekday: number,
): number | null {
  const limit = limits[weekday];
  if (limit === undefined) {
    throw new Error("Missing third-party fulfillment weekday limit");
  }
  return limit;
}

export const ThirdPartyFulfillmentBudgetChange = z.object({
  merchantTeamId: z.string().regex(/^[a-f\d]{24}$/i),
  sourceTeamId: z.string().regex(/^[a-f\d]{24}$/i),
  enabled: z.boolean(),
  limits: ThirdPartyFulfillmentWeeklyOrderLimits,
  expectedRevision: z.string().regex(/^\d+$/),
  requestId: z.string().uuid(),
});
export type ThirdPartyFulfillmentBudgetChange = z.infer<
  typeof ThirdPartyFulfillmentBudgetChange
>;
